export default __webpack_public_path__ + "static/peko2-04f8933f26f7e6d948ca0bccc69d4c7c.jpg";